module.exports = __webpack_public_path__ + "img/9.36bc0918.png";